"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLocals = void 0;
var fetchData = function (url, callback) {
    return fetch(url)
        .then(function (res) {
        return res.json();
    })
        .then(function (jsonResponse) {
        callback(null, { status: 200, data: jsonResponse });
    });
};
function fetchLocals(url, callback, path, fallbackLng) {
    return fetchData(url, callback).catch(function (err) {
        if (fallbackLng) {
            console.log("inside fallbacklng");
            fetchData("".concat(path, "/").concat(fallbackLng, ".json"), callback);
        }
        else {
            // still working as before showing translation key instead of value
            callback(err);
        }
    });
}
exports.fetchLocals = fetchLocals;
